"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
require("./Dialog.scss");
var _Overlay = require("../Overlay/Overlay");
var _core = require("@dragon/core");
var _HtmlButton = require("../HtmlButton");
var _AutoPlayHtmlRangeInput = require("../AutoPlayHtmlRangeInput");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dialog = exports.Dialog = /*#__PURE__*/function () {
  function Dialog(parent) {
    var _this = this;
    _classCallCheck(this, Dialog);
    _defineProperty(this, "_currentElement", void 0);
    _defineProperty(this, "_node", void 0);
    _defineProperty(this, "_overlay", void 0);
    _defineProperty(this, "_topPanelNode", void 0);
    _defineProperty(this, "_middlePanelNode", void 0);
    _defineProperty(this, "_bottomPanelNode", void 0);
    _defineProperty(this, "_header", void 0);
    _defineProperty(this, "_basePanel", void 0);
    _defineProperty(this, "_content", void 0);
    _defineProperty(this, "okBtn", void 0);
    _defineProperty(this, "yesBtn", void 0);
    _defineProperty(this, "exitBtn", void 0);
    _defineProperty(this, "rcHistoryBtn", void 0);
    _defineProperty(this, "noBtn", void 0);
    _defineProperty(this, "handleState", function (state) {
      if (state === _core.DialogState.PROMOTION_START) {
        _this.showBtnOkOnly();
        var _state = _core.CORE.getState();
        _this._content = document.createElement("div");
        _this._content.className = "msg fgstart";
        switch (_state.promotion.type) {
          case _core.PromotionType.FeatureTrigger:
            _this._header.innerHTML = _core.CORE.translate("ftheader");
            if (_state.promotion.rounds === 1) {
              _this._content.innerHTML = _core.CORE.translate("ftstartmsgsing").replace("{0}", _state.promotion.rounds.toString()).replace("{1}", (0, _core.coinsToCurrency)(_state.bet.coinValue));
            } else {
              _this._content.innerHTML = _core.CORE.translate("ftstartmsgplur").replace("{0}", _state.promotion.rounds.toString()).replace("{1}", (0, _core.coinsToCurrency)(_state.bet.coinValue));
            }
            _this.showBtnOkOnly();
            break;
          case _core.PromotionType.FreeGames:
            _this._header.innerHTML = _core.CORE.translate("fgheader");
            if (_state.promotion.roundsPlayed === 0) {
              _this._content.innerHTML = _core.CORE.translate("fgstartmsg").replace("{0}", _state.promotion.rounds.toString());
            } else {
              _this._content.innerHTML = _core.CORE.translate("fgcontinuemsg").replace("{0}", (_state.promotion.rounds - _state.promotion.roundsPlayed).toString());
            }
            break;
          case _core.PromotionType.Frenzy:
            {
              _this._header.innerHTML = _core.CORE.translate("frenzyheader");
              if (_state.promotion.roundsPlayed === 0) {
                _this._content.innerHTML = _core.CORE.translate("frenzystartmsg").replace("{0}", (_state.promotion.durationLeft / 1000).toString());
              } else {
                _this._content.innerHTML = _core.CORE.translate("frenzycontinuemsg").replace("{0}", (_state.promotion.durationLeft / 1000).toString());
              }
              break;
            }
          default:
            break;
        }
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.PROMOTION_END) {
        var _state2 = _core.CORE.getState();
        _this.showBtnOkOnly();
        _this._content = document.createElement("div");
        _this._content.className = "msg fgend";
        switch (_state2.promotion.type) {
          case _core.PromotionType.FeatureTrigger:
            {
              var p0 = document.createElement("div");
              p0.className = "msgwintxt";
              p0.innerHTML = _core.CORE.translate("ftendwintxt");
              _this._content.appendChild(p0);
              var p1 = document.createElement("div");
              p1.className = "msgwin";
              p1.innerHTML = (0, _core.currencyFormatter)(_state2.promotion.totalWin, _state2.balance.currency);
              _this._content.appendChild(p1);
              var p2 = document.createElement("div");
              p2.className = "msgcontent";
              p2.innerHTML = _core.CORE.translate("ftendmsg");
              _this._content.appendChild(p2);
              break;
            }
          case _core.PromotionType.FreeGames:
            {
              _this._header.innerHTML = _core.CORE.translate("fgheader");
              var p0 = document.createElement("div");
              p0.className = "msgwintxt";
              p0.innerHTML = _core.CORE.translate("fgendwintxt");
              _this._content.appendChild(p0);
              var p1 = document.createElement("div");
              p1.className = "msgwin";
              p1.innerHTML = (0, _core.currencyFormatter)(_state2.promotion.totalWin, _state2.balance.currency);
              _this._content.appendChild(p1);
              var p2 = document.createElement("div");
              p2.className = "msgcontent";
              p2.innerHTML = _core.CORE.translate("fgendmsg");
              _this._content.appendChild(p2);
              break;
            }
          case _core.PromotionType.Frenzy:
            {
              _this._header.innerHTML = _core.CORE.translate("frenzyheader");
              var p0 = document.createElement("div");
              p0.className = "msgwintxt";
              p0.innerHTML = _core.CORE.translate("frenzyend");
              _this._content.appendChild(p0);
              var p2 = document.createElement("div");
              p2.className = "msgcontent";
              p2.innerHTML = _core.CORE.translate("frenzyrounds").replace("{0}", '<span class="msgwin">' + _state2.promotion.roundsPlayed.toString() + "</span>");
              _this._content.appendChild(p2);
              var p1 = document.createElement("div");
              p1.className = "msgcontent";
              p1.innerHTML = _core.CORE.translate("frenzytotalwin").replace("{0}", '<span class="msgwin">' + (0, _core.currencyFormatter)(_state2.promotion.totalWin, _state2.balance.currency) + "</span>");
              _this._content.appendChild(p1);
              var p3 = document.createElement("div");
              p3.className = "msgcontent";
              p3.innerHTML = _core.CORE.translate("fgendmsg");
              _this._content.appendChild(p3);
              break;
            }
        }
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.PROMOTION_NEXT) {
        _this.showBtnOkOnly();
        var _state3 = _core.CORE.getState();
        _this._content = document.createElement("div");
        _this._content.className = "msg fgstart";
        switch (_state3.promotion.type) {
          case _core.PromotionType.FeatureTrigger:
            _this._header.innerHTML = _core.CORE.translate("ftheader");
            _this._content.innerHTML = _core.CORE.translate("ftnext");
            //  .replace('{0}', state.promotion.rounds.toString())
            //   .replace('{1}', coinsToCurrency(state.bet.coinValue))

            _this.showBtnOkOnly();
            break;
        }
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.BLITZ_FEATURE) {
        _this.showYesNo();
        _this._content = document.createElement("div");
        _this._content.className = "msg blitzFeature";
        _this._header.innerHTML = _core.CORE.translate("blitzbrH");
        _this._content.innerHTML = _core.CORE.translate("blitzbr");
        _this.yesBtn.setText(_core.CORE.translate("blitzbrOkB"));
        _this.noBtn.setText(_core.CORE.translate("blitzbrNoB"));
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.INSUFFICIENT_BALANCE) {
        _this.showBtnOkOnly();
        _this._header.innerHTML = _core.CORE.translate("ibheader");
        _this._content = document.createElement("div");
        _this._content.className = "msg ib";
        _this._content.innerHTML = _core.CORE.translate("ibmsg");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.UNFINISHED_GAME) {
        _this.showBtnOkOnly();
        _this._header.innerHTML = _core.CORE.translate("ufgheader");
        _this._content = document.createElement("div");
        _this._content.className = "msg ufg";
        _this._content.innerHTML = _core.CORE.translate("ufgmsg");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.LIMITS_REACHED) {
        _this.showBtnOkOnly();
        _this._header.innerHTML = _core.CORE.translate("limitheader");
        _this._content = document.createElement("div");
        _this._content.className = "msg limit";
        _this._content.innerHTML = _core.CORE.translate("limitmsg");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.RG_REMINDER) {
        var _state4 = _core.CORE.getState();
        _this._header.innerHTML = _core.CORE.translate("rgreminderheader");
        _this._content = document.createElement("div");
        _this._content.className = "msg rgreminder";
        _this.exitBtn.action.payload = _core.ExitReason.RealityCheck;
        if (_state4.config.rcAccountHistoryUrl) _this.showYesOkActionBtn();else _this.showYesExit();
        var difference = new Date().getTime() - _state4.responsibleGaming.sessionStarted.getTime(); // This will give difference in milliseconds
        var result = (0, _core.currencyFormatter)(_state4.responsibleGaming.result / 100, _state4.balance.currency, _state4.config.locale);
        _this._content.innerHTML = _core.CORE.translate("rgremindermsg").replace("{0}", Math.round(difference / 60000).toString()).replace("{1}", result);
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.PLAYFORREAL) {
        _this.showYesNo();
        _this._header.innerHTML = _core.CORE.translate("pfrheader");
        _this._content = document.createElement("div");
        _this._content.className = "msg pfr";
        _this.yesBtn.action = {
          type: _core.EXIT,
          payload: _core.ExitReason.PlayForReal
        };
        _this._content.innerHTML = _core.CORE.translate("pfrmsg");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.AUTOPLAY) {
        _this.showYesNo();
        _this._header.innerHTML = _core.CORE.translate("autoplayheader");
        _this._content = document.createElement("div");
        _this._content.className = "msg autoplay";
        new _AutoPlayHtmlRangeInput.AutoPlayHtmlRangeInput(_this._content, true);
        _this.yesBtn.setText(_core.CORE.translate("startBtn"));
        _this.noBtn.setText(_core.CORE.translate("cancelBtn"));
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.REPLAY_START) {
        _this.showBtnOkOnly();
        _this._header.innerHTML = _core.CORE.translate("replayStartHeader");
        _this._content = document.createElement("div");
        _this._content.className = "msg replay";
        _this._content.innerHTML = _core.CORE.translate("replaystart");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.REPLAY_END) {
        _this.showBtnOkOnly();
        _this._header.innerHTML = _core.CORE.translate("replayendHeader");
        _this._content = document.createElement("div");
        _this._content.className = "msg replay";
        _this._content.innerHTML = _core.CORE.translate("replayend");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.REPLAY_START_LAUNCH) {
        var _state5 = _core.CORE.getState();
        _this.showBtnOkOnly();
        _this._header.innerHTML = _core.CORE.translate("replayLaunchStartHeader");
        _this._content = document.createElement("div");
        _this._content.className = "msg replay";
        _this._content.innerHTML = _core.CORE.translate("replaylaunchstart").replace('{0}', _state5.replay.coinsWinXBet.toFixed(0));
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.REPLAY_END_LAUNCH) {
        _this.showYesNo();
        _this._header.innerHTML = _core.CORE.translate("replayLaunchEndHeader");
        _this._content = document.createElement("div");
        _this._content.className = "msg replay";
        _this._content.innerHTML = _core.CORE.translate("replaylaunchend");
        _this._middlePanelNode.appendChild(_this._content);
        _this.openDialog();
      } else if (state === _core.DialogState.CUSTOM) {
        //   this.showBtnOkOnly();
        var _state6 = _core.CORE.getState();
        _this._header.innerHTML = _state6.ui.dialogCustomHeader;
        _this._content = _this.createContentDiv(_state6.ui.dialogCustomContent);
        _this._middlePanelNode.appendChild(_this._content);
        switch (_state6.ui.dialogCustomActions) {
          case 'YESEXIT':
            _this.showYesExit();
            break;
          case 'YESNO':
            _this.showYesNo();
            break;
          default:
            _this.showBtnOkOnly();
            break;
        }
        _this.openDialog();
      } else {
        if (_this._content) {
          _this._middlePanelNode.removeChild(_this._content);
          _this._content = undefined;
        }
        _this.closeDialog();
      }
    });
    _defineProperty(this, "openDialog", function () {
      _this._overlay.show();
    });
    /**
     * Sets the default texts on the buttons.
     */
    _defineProperty(this, "resetButtonTexts", function () {
      _this.okBtn.setText(_core.CORE.translate("okbtn"));
      _this.yesBtn.setText(_core.CORE.translate("yesbtn"));
      _this.rcHistoryBtn.setText(_core.CORE.translate("historybtn"));
      _this.exitBtn.setText(_core.CORE.translate("exitbtn"));
      _this.noBtn.setText(_core.CORE.translate("noBtn"));
    });
    _defineProperty(this, "closeDialog", function () {
      if (_this._currentElement) {
        _this._currentElement.style.display = "none";
      }
      _this._overlay.hide();
      _this.resetButtonTexts();
    });
    _defineProperty(this, "hideAll", function () {
      _this.noBtn.hide();
      _this.exitBtn.hide();
      _this.yesBtn.hide();
      _this.rcHistoryBtn.hide();
      _this.okBtn.hide();
    });
    _defineProperty(this, "showBtnOkOnly", function () {
      _this.hideAll();
      _this.okBtn.show();
    });
    _defineProperty(this, "showYesExit", function () {
      _this.hideAll();
      _this.exitBtn.show();
      _this.yesBtn.show();
    });
    _defineProperty(this, "showYesOkActionBtn", function () {
      _this.hideAll();
      _this.exitBtn.show();
      _this.yesBtn.show();
      _this.rcHistoryBtn.show();
    });
    _defineProperty(this, "showYesNo", function () {
      _this.hideAll();
      _this.yesBtn.show();
      _this.noBtn.show();
    });
    // Create overlay
    this._overlay = new _Overlay.Overlay(parent, null);
    this._node = document.createElement("div");
    this._node.className = "uiDialog";

    /// note that the Dialog is a child of the overlay.
    this._overlay.getNode().appendChild(this._node);

    // for this overlay we prevent clickthrough, so user dont manage to click on things under. only dialog buttons
    this._overlay.getNode().style.pointerEvents = "auto";
    var preventClickthrough = function preventClickthrough(e) {
      e.stopPropagation();
    };
    this._overlay.getNode().onclick = preventClickthrough;
    this._overlay.getNode().ontouchstart = preventClickthrough;
    this._overlay.getNode().ontouchend = preventClickthrough;

    //base
    this._basePanel = document.createElement("div");
    this._basePanel.className = "base";
    this._node.appendChild(this._basePanel);

    // Create Top panel.
    this._topPanelNode = document.createElement("div");
    this._topPanelNode.className = "uiDialogTopPanel";
    this._basePanel.appendChild(this._topPanelNode);

    // Create bottom panel.
    this._middlePanelNode = document.createElement("div");
    this._middlePanelNode.className = "uiDialogMiddlePanel";
    this._basePanel.appendChild(this._middlePanelNode);

    // Create bottom panel.
    this._bottomPanelNode = document.createElement("div");
    this._bottomPanelNode.className = "uiDialogBottomPanel";
    this._basePanel.appendChild(this._bottomPanelNode);
    this._header = document.createElement("h1");
    this._topPanelNode.appendChild(this._header);
    this._topPanelNode.appendChild(document.createElement("hr"));
    this._bottomPanelNode.appendChild(document.createElement("hr"));
    this.okBtn = new _HtmlButton.HtmlButton(this._bottomPanelNode, "dialogBtnC", "matBtn okBtn", _core.DIALOG_OK);
    this.yesBtn = new _HtmlButton.HtmlButton(this._bottomPanelNode, "dialogBtnC", "matBtn yesBtn", _core.DIALOG_OK);
    this.rcHistoryBtn = new _HtmlButton.HtmlButton(this._bottomPanelNode, "dialogBtnC", "matBtn historyBtn yellow", _core.EXIT, {
      type: _core.EXIT,
      payload: _core.ExitReason.RealityCheckHistory
    });
    this.exitBtn = new _HtmlButton.HtmlButton(this._bottomPanelNode, "dialogBtnC", "matBtn exitBtn red", _core.EXIT, {
      type: _core.EXIT,
      payload: _core.ExitReason.Regular
    });
    this.noBtn = new _HtmlButton.HtmlButton(this._bottomPanelNode, "dialogBtnC", "matBtn noBtn yellow", _core.DIALOG_NO);
    this.resetButtonTexts();
    _core.CORE.subscribe("ui.dialogState", this.handleState);
  }
  return _createClass(Dialog, [{
    key: "createContentDiv",
    value: function createContentDiv(content) {
      var contentEl = document.createElement("div");
      contentEl.className = "msg replay";
      contentEl.innerHTML = content;
      return contentEl;
    }
  }]);
}();
//# sourceMappingURL=Dialog.js.map